import PartnerEndpoints from "../../pages/Customer/endpoints";
import ExternalTemplates from "../../pages/Customer/externalTemplates";
import { createProtectedRoutes } from "../../utils/createdProtectedRoutes";
import MessageTemplates from "../../pages/Administration/rcs/MessageTemplates";
import DetailMessageTemplate from "../../pages/Administration/rcs/DetailMessageTemplate";
export const ROUTE = "Partner";

const routesConfig = [
  { path: `${ROUTE}/EndPoints`, component: PartnerEndpoints, roles: [1, 2, 3] },
  {
    path: `${ROUTE}/ExternalTemnplates`,
    component: ExternalTemplates,
    roles: [1, 2, 3],
  },
];

const rcsPartnerConfig = [
  {
    path: `RCS/MessageTemplates`,
    component: MessageTemplates,
    roles: [2, 3],
  },
  {
    path: `RCS/MessageTemplates/:uuid_message_template`,
    component: DetailMessageTemplate,
    roles: [2, 3],
  },
  {
    path: `RCS/MessageTemplates/create`,
    component: DetailMessageTemplate,
    roles: [2, 3],
  },
];

const partnerRoutes = createProtectedRoutes(
  routesConfig.concat(rcsPartnerConfig),
);
export default partnerRoutes;
